// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBa1qTZVehIs-N6k3f2UHbZ2kwbZG0nhNQ",
    authDomain: "mozarttest-2e2e5.firebaseapp.com",
    projectId: "mozarttest-2e2e5",
    storageBucket: "mozarttest-2e2e5.appspot.com",
    messagingSenderId: "749811653681",
    appId: "1:749811653681:web:851cda4818e06663d58910"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
